export const environment = {
  production: true,
  company: 'testcentraal',
  APIUrl: 'https://test.backend.jbmsoftware.nl/',
  SocketIO_EndPoint: 'https://test.backend.jbmsoftware.nl',
  RecipeAppSupport:true
};
